import { render } from "./Quotation6.vue?vue&type=template&id=14db18ea"
import script from "./Quotation6.vue?vue&type=script&lang=js"
export * from "./Quotation6.vue?vue&type=script&lang=js"
script.render = render

export default script